import {CounterInputStyle} from "../cart.style";
import {Button} from "reactstrap";
import {FaMinus, FaPlus} from "react-icons/fa6";

const CounterInput = ({ value = 1, max = 1, min, halfSlotSupported = false, onChange }) => {
    const minimum = min ?? (halfSlotSupported ? 0.5 : 1);
    const numericValue = Number(value);
    const numericMax = Number(max);
    const step = halfSlotSupported ? 0.5 : 1;
    const roundToStep = (quantity) => Math.round(quantity / step) * step;
    const nextValue = roundToStep(numericValue + step);
    const previousValue = Math.max(roundToStep(numericValue - step), minimum);

    const increase = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!Number.isFinite(numericMax) || nextValue <= numericMax) onChange(nextValue);
    };

    const decrease = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(previousValue);
    };

    const handleInputClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <CounterInputStyle onClick={handleInputClick} className="relative flex items-center">
            <Button disabled={numericValue <= minimum} onClick={decrease} size="sm" type="button" aria-label="Decrease slots">
                <FaMinus size={18} />
            </Button>
            <input value={value} readOnly type="text" id="counter-input" required />
            <Button disabled={numericValue >= numericMax || nextValue > numericMax} onClick={increase} size="sm" type="button" aria-label="Increase slots">
                <FaPlus size={18} />
            </Button>
        </CounterInputStyle>
    );
};
export default CounterInput
